export const CATEGORIES=[
    {image:"https://files.myglamm.com/site-images/original/SKin-1-2.png",
    name:"Skin"  
  },{image:"https://files.myglamm.com/site-images/original/Lips-3.png",
  name:"Lips"  
  },{image:"https://files.myglamm.com/site-images/original/Superfoods-Model-120-X-120-px_2.jpg",
  name:"Hair"  
  },{image:"https://files.myglamm.com/site-images/original/Eyes-4.png",
  name:"Eyes"  
  },{image:"https://files.myglamm.com/site-images/original/Face-5.png",
  name:"Face"  
  },{image:"https://files.myglamm.com/site-images/original/Nails-1.png",
  name:"Nails"  
  },{image:"https://files.myglamm.com/site-images/original/App-PersonalCare_2.png",
  name:"Sanitizing Care"  
  },{image:"https://files.myglamm.com/site-images/original/Bath.png",
  name:"Bath & Body"  
  },
  ];

  export const kitsAndCombo=[
    {
      image:"https://files.myglamm.com/site-images/original/desktop-mk-combo.jpg",
      name:"Makeup Combos",
      data:"makeup"
    },{
      image:"https://files.myglamm.com/site-images/original/desktop-skin-combo.jpg",
      name:"SkinCare Combos",
      data:"skincare"
    }
    ,{
      image:"https://files.myglamm.com/site-images/original/Desktop-combo.jpg",
      name:"Beaut Kits Under 499",
      data:"makeup"
    }
  
  ];
  
  
  
  export const inTheSportLight=[
    {image:"https://files.myglamm.com/site-images/original/700x-488-monsoon.jpg",
    name:"Monsoon Skincare Essentials"
        },
    {image:"https://files.myglamm.com/site-images/original/700x488-sheet-mask.gif"
    ,
    name:"Buy 3 and Get 3 Sheet Masks"},
    {image:"https://files.myglamm.com/site-images/original/LIT700x488_1.jpg",
    name:"Shop More, Save More"}

  ];

  export const ESSENTIALBUDGETBUYS=[
    {image:"https://files.myglamm.com/site-images/original/combo-Banner--700-x-488_1.jpg",
    name:"Wipeout",data:"facewash"},
    {image:"https://files.myglamm.com/site-images/original/Glamm-Picks-700x488.jpg",
    name:"Under 499 Store",data:"LIPSTICK"},
    {image:"https://files.myglamm.com/site-images/original/Glamm-Must-haves-desktop.jpg",
    name:"Under 999 Store",data:"lipstick"}
  ];

  export const WALLETOFFERS=[
    {image:"https://files.myglamm.com/site-images/original/CRED-Pay-700x488-_1.jpg"},
    {image:"https://files.myglamm.com/site-images/original/mobikwik-700x488_1.jpg"},
    {image:"https://files.myglamm.com/site-images/original/simpl-700x488-_1.jpg"}
  ];

export const BANKPARTNER=[
    {image:"https://files.myglamm.com/site-images/original/Twid-Pay-700x488-.jpg"},
    {image:"https://files.myglamm.com/site-images/original/IDFC-offer-700x488-_1.jpg"},
    {image:"https://files.myglamm.com/site-images/original/IDFC-offer-700x488-.jpg"}
  ];

  
            
export const carouselData=[
  {
  id: 1,
  image: "https://files.myglamm.com/site-images/400x400/OTTP-(1).jpg",
  name: "MyGlamm LIT Liquid Matte Lipstick - OTP",
  subtitle: "Moringa Oil Enriched Matte Lipstick",
  avg_rating: "4.9",
  totalratings: "12044",
  offerPrice: "395",
  actualPrice: ""
  },
  {
  id: 2,
  image:"https://files.myglamm.com/site-images/400x400/Soft-Matte-post-1-Poppy-Pink.jpg",
  name:"Manish Malhotra Soft Matte Lipstick - Poppy Pink",
  subtitle: "Hydrating Long-wear Lipstick",
  avgrating: "4.9",
  totalratings: "584",
  offerPrice: "665",
  actualPrice: "950"
  },
  {
  id: 3,
  image: "https://files.myglamm.com/site-images/400x400/Facewash_3.jpg",
  name: "MyGlamm WIPEOUT Germ Killing Face Wash",
  subtitle: "Tea Tree Oil & Vitamin E-infused Face Wash",
  avgrating: "4.9",
  totalratings: "658",
  offerPrice: "89",
  actualPrice: "119"
  },
  {
  id: 5,
  image: "https://files.myglamm.com/site-images/400x400/OTTP-(1).jpg",
  name: "MyGlamm LIT Liquid Matte Lipstick - OTP",
  subtitle: "Moringa Oil Enriched Matte Lipstick",
  avgrating: "4.9",
  totalratings: "12044",
  offerPrice: "395",
  actualPrice: ""
  },
  {
  id: 6,
  image: "https://files.myglamm.com/site-images/400x400/Soft-Matte-post-1-Poppy-Pink.jpg",
  name: "Manish Malhotra Soft Matte Lipstick - Poppy Pink",
  subtitle: "Hydrating Long-wear Lipstick",
  avgrating: "4.9",
  totalratings: "584",
  offerPrice: "665",
  actualPrice: "950"
  },
  {
  id: 7,
  image: "https://files.myglamm.com/site-images/400x400/Hi-Shine-Post-1-Mauve-Struck.jpg",
  name: "Manish Malhotra Hi-Shine Lipstick - Mauve Struck",
  subtitle: "Lightweight, Long-wear Lipsticks",
  avgrating: "4.9",
  totalratings: "1125",
  offerPrice: "712",
  actualPrice: "950"
  },
  {
  id: 8,
  image: "https://files.myglamm.com/site-images/400x400/MHML-(1).jpg",
  name: "MyGlamm LIT Creamy Matte Lipstick - Manhattan",
  subtitle: "Precision Perfect Matte Slimstick",
  avgrating: "4.9",
  totalratings: "605",
  offerPrice: "416",
  actualPrice: "595"
  },
  {
  id: 9,
  image: "https://files.myglamm.com/site-images/400x400/Soft-Matte-post-1-Poppy-Pink.jpg",
  name: "Manish Malhotra Soft Matte Lipstick - Poppy Pink",
  subtitle: "Hydrating Long-wear Lipstick",
  avgrating: "4.9",
  totalratings: "584",
  offerPrice: "665",
  actualPrice: "950"
  },
  {
  id: 10,
  image: "https://files.myglamm.com/site-images/400x400/Facewash_3.jpg",
  name: "MyGlamm WIPEOUT Germ Killing Face Wash",
  subtitle: "Tea Tree Oil & Vitamin E-infused Face Wash",
  avgrating: "4.9",
  totalratings: "658",
  offerPrice: "89",
  actualPrice: "119"
  },
  {
  id: 11,
  image: "https://files.myglamm.com/site-images/400x400/Body-wash_4.jpg",
  name: "MyGlamm WIPEOUT Germ Killing Body Wash",
  subtitle: "Tea Tree Oil-infused Skin-regenerating Body Wash",
  avgrating: "5",
  totalratings: "121",
  offerPrice: "169",
  actualPrice: "199"
  },
  {
  id: 12,
  image: "https://files.myglamm.com/site-images/400x400/Facewash_3.jpg",
  name: "MyGlamm WIPEOUT Germ Killing Face Wash",
  subtitle: "Tea Tree Oil & Vitamin E-infused Face Wash",
  avgrating: "4.9",
  totalratings: "658",
  offerPrice: "89",
  actualPrice: "119"
  },
  {
  id: 13,
  image: "https://files.myglamm.com/site-images/400x400/Hi-Shine-Post-1-Mauve-Struck.jpg",
  name: "Manish Malhotra Hi-Shine Lipstick - Mauve Struck",
  subtitle: "Lightweight, Long-wear Lipsticks",
  avrating: "4.9",
  totalratings: "1125",
  offerPrice: "712",
  actualPrice: "950"
  },
  {
  id: 15,
  image: "https://files.myglamm.com/site-images/400x400/Artboard-1-(1)-(1).jpg",
  name: "MyGlamm SUPERFOODS Kajal - Indigo - 0.35g",
  subtitle: "Long-Wear Smudge-Proof Kajal Infused With Natural Superfood Extracts",
  avgrating:4.9,
  totalratings: 1153,
  offerPrice: 296,
  actualPrice: 395
  }
  ]; 